// extracted by mini-css-extract-plugin
export default {"wrapper":"tabbar_wrapper__TUkT3","tab":"tabbar_tab__-XsDW","selectedTab":"tabbar_selectedTab__NC0BZ","text":"tabbar_text__jySeE"};